export const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

// Right-to-left languages (reserved for future use — currently none active).
export const RTL_LANGS = [];

// Shared destination list (proper nouns – kept identical across languages)
const RIVIERA_DESTINATIONS = [
  "Nice",
  "Cannes",
  "Monaco · Monte-Carlo",
  "Saint-Tropez",
  "Saint-Jean-Cap-Ferrat",
  "Antibes · Juan-les-Pins",
  "Èze",
  "Villefranche-sur-Mer",
];

const NICE_ROUTES = [
  { from: "Aéroport Nice", to: "Monaco" },
  { from: "Aéroport Nice", to: "Cannes" },
  { from: "Aéroport Nice", to: "Saint-Tropez" },
  { from: "Aéroport Nice", to: "Cap-Ferrat" },
  { from: "Aéroport Nice", to: "Antibes" },
  { from: "Aéroport Nice", to: "Èze · Villefranche" },
];

export const translations = {
  fr: {
    nav: { home: "Accueil", servicesPage: "Services & Flotte", fleetPage: "Flotte", contactPage: "Contact & Avis", book: "Devis", themeDark: "Passer en nuit alpine", themeLight: "Passer en mode clair" },
    landing: {
      hero: {
        titleLine1: "Chauffeur privé",
        titleLine2: "Alpes & Savoie",
        subtitlePre: "Transferts privés depuis les aéroports de ",
        subtitleBold1: "Genève, Chambéry, Annecy, Lyon et Grenoble",
        subtitleMid: " vers ",
        subtitleBold2: "Courchevel, Val d'Isère, Tignes, Megève et Chamonix",
        subtitlePost: ". Chauffeur à la semaine, cortèges et mises à disposition sur toutes les stations alpines — également disponibles sur la Côte d'Azur et pour vos longues distances en France.",
        tags: {
          ski: "Transferts stations",
          airports: "Aéroports Alpes",
          dedicated: "Chauffeur à la semaine",
          event: "Événements & Cortèges",
          riviera: "Côte d'Azur",
          longhaul: "Longue distance",
        },
        ctaQuote: "Demander un devis",
        ctaDiscover: "Découvrir la maison",
        rating: "5.0 · Google",
        trust24: "Disponible 24/7",
        trustReply: "Réponse rapide",
        trustDiscretion: "Discrétion absolue",
      },
      prestations: {
        overline: "Nos prestations",
        titleLine1: "Six façons de ",
        titleLine2: "voyager avec nous",
        subtitle: "Chaque prestation est traitée sur mesure. Nous étudions votre demande, mobilisons le véhicule et le chauffeur les plus appropriés, et vous adressons un devis détaillé sous quatre heures.",
        detailsCta: "Détails",
        services: {
          ski: { title: "Transferts stations de ski", subtitle: "Aéroports Alpes & Savoie", text: "Depuis Genève, Chambéry, Annecy, Lyon ou Grenoble vers Courchevel, Val d'Isère, Tignes, Megève, Chamonix. Suivi de vol, bagages et skis à bord." },
          dedicated: { title: "Chauffeur à la semaine", subtitle: "En station, du dimanche au samedi", text: "Un chauffeur attitré pour toute la semaine en station — restaurants, pistes, aéroport retour. Idéal familles et séjours Noël, Nouvel An ou vacances d'hiver." },
          disposal: { title: "Mise à disposition", subtitle: "À l'heure, à la journée, longue durée", text: "Chauffeur privé à votre disposition — quelques heures, une journée, un séjour complet. Vous montez, vous descendez, vous reprenez." },
          event: { title: "Événements & Cortèges", subtitle: "Mariages, galas, Festivals, GP", text: "Mariages en station, séminaires d'entreprise, Festival de Cannes, Grand Prix de Monaco, Yacht Show — coordination complète et cortèges Mercedes." },
          riviera: { title: "Côte d'Azur", subtitle: "En complément de l'activité Alpes", text: "Nice, Cannes, Monaco, Saint-Tropez, Cap-Ferrat : transferts, soirées, mises à disposition. Grande réactivité, même en dernière minute." },
          longhaul: { title: "Longue distance", subtitle: "France, Monaco, Italie, Suisse, Espagne", text: "Alpes ↔ Paris, Lyon, Genève, Milan. Nice ↔ Paris, Barcelone, Portofino. Trajets longue distance sur mesure, tout confort, sans limite kilométrique." },
        },
      },
      fleetPreview: {
        overline: "Notre flotte",
        titleLine1: "Trois signatures Mercedes,",
        titleLine2: "zéro compromis.",
        introPre: "Notre ",
        introBold1: "Mercedes Classe V",
        introMid: " est notre véhicule en pleine propriété, entretenu et briefé par nos soins. Les ",
        introBold2: "Classe S et Classe E",
        introAfterBold2: ", ainsi que les véhicules d'exception (",
        introItalic: "Maybach, Rolls-Royce, Bentley, Ferrari",
        introPost: "), sont mobilisés via notre réseau de chauffeurs partenaires soigneusement choisis.",
        detailsCta: "Détails",
        viewAll: "Voir la flotte en détail",
        cars: {
          v: { kicker: "Van VIP · Notre flotte", title: "Mercedes Classe V", line: "Notre véhicule signature, en pleine propriété — jusqu'à 6 passagers (confort réel + bagages), ciel étoilé fibre optique, écrans et sièges capitaine. Idéal transferts stations avec bagages et skis.", photoAlt: "Mercedes Classe V AMB Élite, van VIP en pleine propriété — Côte d'Azur et stations alpines" },
          s: { kicker: "Berline · Via partenaires", title: "Mercedes Classe S", line: "Discrétion d'affaires, roulage silencieux, arrière lounge — mobilisée via notre réseau de partenaires de confiance pour dirigeants et missions VIP.", photoAlt: "Mercedes Classe S noire de face — AMB Élite, berline directoriale (partenaires)" },
          e: { kicker: "AMG Coupé · Via partenaires", title: "Mercedes Classe E AMG", line: "Coupé sport-luxe disponible via nos chauffeurs partenaires pour arrivées remarquées, escortes courtes et transferts à deux.", photoAlt: "Mercedes Classe E AMG Coupé noire — service AMB Élite via partenaires" },
        },
      },
      destinations: {
        overline: "Nos destinations",
        titleLine1: "Là où ",
        titleLine2: "nous roulons",
        subtitle: "Deux terrains, un même niveau d'exigence — les Alpes en priorité, la Côte d'Azur en complément. Chaque adresse est connue de nos chauffeurs, chaque itinéraire préparé en amont.",
        alpes: {
          kicker: "Alpes & Savoie · Notre spécialité",
          title: "Les grandes stations, en Mercedes",
          textPre: "",
          textBold1: "Courchevel",
          textMid1: ", ",
          textBold2: "Val d'Isère",
          textMid2: " et ",
          textBold3: "Tignes",
          textPost: " — trois adresses de cœur pour AMB Élite. Transferts depuis Genève, Chambéry, Annecy, Lyon ou Grenoble, chauffeur dédié à la semaine, véhicules équipés hiver.",
          prefillAriaPrefix: "Pré-remplir le devis avec destination",
          prefillHint: "Devis",
        },
        riviera: {
          kicker: "Côte d'Azur · En complément",
        },
      },
      ourHouse: {
        overline: "La Maison AMB Élite",
        titleLine1: "Une maison de chauffeurs,",
        titleLine2: "pas un service.",
        paragraph1: "AMB Élite est né d'une conviction simple\u00a0: le luxe véritable ne tient pas au véhicule, mais à la personne au volant. Nous sommes une maison à taille humaine, réunissant une équipe restreinte de chauffeurs sélectionnés — chacun choisi pour son sens du service, sa discrétion et sa parfaite connaissance des lieux qu'il traverse.",
        paragraph2Pre: "Nous accompagnons dirigeants d'entreprises, familles fortunées, productions internationales et invités de palaces au fil de leurs trajets. Des ",
        paragraph2Bold1: "Alpes",
        paragraph2Mid: " à la ",
        paragraph2Bold2: "Côte d'Azur",
        paragraph2Post: ", de Paris à Milan, nos prestations couvrent toute la France et se prolongent naturellement vers l'Italie, la Suisse, l'Espagne et la Principauté de Monaco.",
        paragraph3Pre: "Notre véhicule principal — la ",
        paragraph3Bold1: "Mercedes Classe V",
        paragraph3Mid: " — est en pleine propriété, entretenu avec soin et adapté à chaque occasion. Pour les Mercedes ",
        paragraph3Bold2: "Classe S et E",
        paragraph3AfterBold2: ", et pour les demandes les plus particulières, nous mobilisons sur commande des véhicules d'exception (",
        paragraph3Italic: "Maybach, Rolls-Royce, Bentley",
        paragraph3Post: ") et un réseau de chauffeurs partenaires soigneusement choisis\u00a0: agents de sécurité rapprochée, hôteliers, wedding planners.",
        ctaStory: "Notre histoire",
        ctaQuote: "Demander un devis",
        statLabel: "Disponibilité continue",
        statHint: "Devis dans les meilleurs délais, par WhatsApp ou email",
        photoAlt: "Mercedes Classe V AMB Élite devant un chalet alpin à Courchevel — transfert privé stations de ski",
      },
      manifesto: {
        overline: "Notre manifeste",
        titleLine1: "Chaque trajet",
        titleLine2a: "est ",
        titleLine2b: "une signature",
        titleLine2c: ".",
        subtitle: "Une maison à taille humaine, engagée dans le seul métier qu'elle connaît vraiment\u00a0: conduire, avec exigence.",
        paragraph1: "L'exigence commence bien avant que la portière ne s'ouvre. Elle se cache dans les détails que personne ne voit — la propreté impeccable du tapis, la fraîcheur d'une bouteille d'eau posée en attention, la connaissance précise du raccourci qui vous fera arriver à l'heure malgré les cortèges du Festival. AMB Élite s'est construite sur cette conviction\u00a0: le luxe n'est pas ce qui se montre, mais ce qui se ressent.",
        paragraph2: "Nous ne vendons pas des kilomètres. Nous accompagnons des instants — parfois ordinaires, souvent décisifs. Un rendez-vous d'affaires à Monaco, un mariage sur les hauteurs du Cap-Ferrat, un transfert privé pour une famille qui vient de descendre d'un jet à Nice-Côte d'Azur. Chaque prestation est étudiée en amont, vérifiée deux fois plutôt qu'une, et confiée à un chauffeur que nous connaissons personnellement.",
        paragraph3: "Nos chauffeurs parlent anglais couramment, connaissent Courchevel, Val d'Isère et la Côte d'Azur comme leurs poches, et savent quand parler comme quand se taire. Vêtus d'un costume sombre — noir ou bleu nuit — la cravate discrète, ils incarnent une certaine idée du service à la française\u00a0: précis, chaleureux, jamais ostentatoire.",
        pillars: [
          { kicker: "Savoir-faire", label: "d'un chauffeur privé formé aux codes du grand luxe — Côte d'Azur, Alpes, France entière" },
          { kicker: "Petite équipe", label: "de chauffeurs sélectionnés à la main, formés à la conduite VIP" },
          { kicker: "24/7", label: "disponibilité continue, réponse dans les meilleurs délais" },
          { kicker: "Français · Anglais", label: "communication limpide avec la clientèle internationale, sans détour" },
        ],
        quote: "«\u00a0Ce qui distingue un chauffeur d'un chauffeur d'exception, c'est ce que le client ne remarque pas. Le trajet doit paraître évident\u00a0— tout le reste est notre affaire.\u00a0»",
        quoteAuthor: "— Quentin Bernard, fondateur AMB Élite",
        ctaStory: "Notre histoire complète",
        ctaQuote: "Demander un devis",
      },
      territoires: {
        overline: "Nos territoires",
        titleLine1: "Deux terrains.",
        titleLine2: "Un même niveau de service.",
        introPre: "AMB Élite est spécialisée sur les ",
        introBold1: "Alpes et la Savoie",
        introMid: " en priorité, et accompagne également ses clients sur la ",
        introBold2: "Côte d'Azur",
        introPost: " et partout en France, toute l'année.",
        alpes: {
          overline: "Notre territoire principal",
          kicker: "Alpes & Savoie",
          titleLine1: "Les Alpes,",
          titleLine2: "l'écrin de neige",
          bodyPre: "Courchevel, Val d'Isère, Tignes, Megève, Chamonix — notre terrain d'expertise prioritaire. Transferts depuis les aéroports de Genève, Chambéry, Annecy, Lyon ou Grenoble, chauffeur dédié à la semaine en station, cortèges pour les grands séjours de Noël, du Nouvel An et des ",
          bodyItalic: "vacances d'hiver",
          bodyPost: ". Véhicules équipés hiver, chauffeurs aguerris aux routes de montagne.",
          spots: ["Courchevel 1850", "Val d'Isère", "Tignes", "Megève", "Chamonix Mont-Blanc", "Méribel · Val Thorens", "Genève · Chambéry · Annecy", "Lyon · Grenoble"],
          cta: "Découvrir les Alpes",
          photoAlt: "Mercedes Classe V AMB Élite devant un chalet des Alpes, intérieur ciel étoilé rouge — Courchevel",
        },
        riviera: {
          overline: "En complément",
          kicker: "Côte d'Azur",
          titleLine1: "La Riviera,",
          titleLine2: "en grand luxe",
          bodyPre: "De Nice à Saint-Tropez, en passant par Monaco, Cannes, Cap-Ferrat et Èze — nous assurons également les transferts et mises à disposition sur la French Riviera, avec une intensité maximale de mai à septembre\u00a0: ",
          bodyItalic: "Festival de Cannes, Grand Prix de Monaco, Yacht Show, mariages Riviera",
          bodyPost: ".",
          spots: ["Nice", "Monaco · Monte-Carlo", "Cannes · Croisette", "Saint-Tropez", "Saint-Jean-Cap-Ferrat", "Antibes · Juan-les-Pins", "Èze · Villefranche", "Sanremo · Italie"],
          cta: "Découvrir la Riviera",
          photoAlt: "Mercedes Classe V AMB Élite sous un pin parasol face à la Méditerranée, Côte d'Azur",
        },
      },
    },
    home: {
      destinations: {
        overline: "Nos destinations",
        title: "La Côte d'Azur, en grand luxe",
        subtitle: "Nice, Cannes, Monaco, Saint-Tropez, Cap-Ferrat, Antibes, Èze… Nous couvrons l'intégralité de la Côte d'Azur, 7j/7.",
        list: RIVIERA_DESTINATIONS,
        cta: "Demander un devis",
        prefillHint: "Pré-remplir le devis",
        prefillAriaPrefix: "Pré-remplir le devis avec destination",
      },
      niceTransfers: {
        overline: "Hub principal",
        title: "Transferts depuis l'Aéroport Nice Côte d'Azur",
        subtitle: "Accueil chauffeur privé, Meet & Greet, suivi des vols, transferts vers hôtels 5★, villas privées, yachts et événements VIP.",
        hubLabel: "Aéroport Nice Côte d'Azur",
        routes: NICE_ROUTES,
        also: "Également : Aéroport de Cannes-Mandelieu, héliports privés (Monaco, Cannes, Saint-Tropez), aviation d'affaires et longues distances en France entière sur demande.",
        cta: "Réserver mon transfert",
        prefillHint: "Pré-remplir le devis",
        prefillAriaPrefix: "Pré-remplir le devis",
      },
    },
    hero: {
      // Winter content preserved for future reactivation – not displayed in UI
      winter: {
        overline: "Chauffeur privé prestige · Alpes & Savoie",
        chip: "Saison hiver — Alpes & stations de ski",
        title: "L'excellence sur les routes des Alpes",
        subtitle: "Transferts et mises à disposition en Mercedes Classe V, S & E.",
      },
      summer: {
        overline: "Chauffeur privé prestige · Alpes & Côte d'Azur",
        chip: "Alpes · Savoie · Côte d'Azur · France entière",
        title: "Chauffeur privé prestige sur les Alpes et la Côte d'Azur",
        subtitle: "Transferts aéroports Genève, Chambéry, Lyon → stations alpines, mises à disposition et grands événements en Mercedes Classe V, S & E. Service 24/7 — également sur la Côte d'Azur et longue distance en France entière sur demande.",
      },
      cta: "Demander un devis",
      discover: "Découvrir nos services",
    },
    banner: {
      title: "Besoin d'un départ immédiat ?",
      text: "Un imprévu ? Bloqué quelque part ? Nous répondons en quelques minutes sur WhatsApp, 7j/7 — même en dernière minute.",
      cta: "Écrire sur WhatsApp",
    },
    services: {
      overline: "Nos services",
      title: "De la grande prestation, sans compromis",
      subtitle: "Chaque prestation est traitée sur mesure : un chauffeur dédié, un véhicule préparé, un briefing en amont sur vos préférences. Vous n'avez qu'à monter à bord.",
      badge: "Spécialité",
      ski: { title: "Transferts stations de ski", desc: "Courchevel 1850, Val d'Isère, Tignes, Megève, Chamonix Mont-Blanc, Méribel, Val Thorens, Les Arcs. Transferts depuis Genève, Chambéry, Annecy, Lyon ou Grenoble — chauffeur dédié à la semaine sur les grandes stations, cortèges pour Noël et vacances d'hiver." },
      riviera: { title: "Côte d'Azur — en complément", desc: "Nice, Cannes, Monaco, Saint-Tropez, Cap-Ferrat : transferts, soirées, mises à disposition. Grande réactivité, même en dernière minute." },
      transfers: { title: "Aéroports & longue distance", desc: "Aéroports Genève, Chambéry, Annecy, Lyon, Grenoble, Nice Côte d'Azur, Cannes-Mandelieu, héliports, gares. Pour les longues distances et grands événements, nous nous déplaçons partout en France." },
      disposal: { title: "Mise à disposition flexible", desc: "Chauffeur et véhicule dédiés pour la durée que vous choisissez. Heures ajoutables en cours de route, plusieurs véhicules et chauffeurs si besoin." },
      events: { title: "Grands événements", desc: "Festival de Cannes, Grand Prix de Monaco, Yacht Show, mariages, séminaires : une logistique irréprochable, sur la Riviera et au-delà." },
      languages: { title: "Clientèle internationale", desc: "Chauffeurs francophones parlant anglais couramment. Notre site est traduit en 6 langues (français, anglais, italien, allemand, espagnol, arabe) pour vous accueillir dans la vôtre." },
      security: { title: "Sécurité privée & protection", desc: "En partenariat avec des agents de sécurité privée pour vos déplacements les plus sensibles : discrétion et protection rapprochée sur demande." },
    },
    fleet: {
      overline: "Notre flotte",
      title: "Mercedes-Benz, exclusivement",
      desc: "Classe V en pleine propriété, Classes S et E mobilisées via notre réseau de chauffeurs partenaires de confiance.",
      classes: [
        { name: "Classe V", tag: "Notre flotte · Jusqu'à 6 passagers", desc: "Notre véhicule signature, en pleine propriété : le salon privé sur la route, idéal familles, groupes et transferts avec bagages et skis." },
        { name: "Classe S", tag: "Via partenaires · Prestige absolu", desc: "La référence du luxe pour vos trajets d'exception, mobilisée via nos chauffeurs partenaires soigneusement sélectionnés." },
        { name: "Classe E", tag: "Via partenaires · Sur demande", desc: "L'élégance business pour vos déplacements professionnels, assurée par notre réseau de chauffeurs partenaires." },
      ],
      note: "Eau offerte · WiFi & chargeurs · Sièges enfants sur demande",
      cortege: { title: "Cortèges & délégations", desc: "Jusqu'à 10 véhicules avec chauffeurs pour vos cortèges, mariages, délégations et grands groupes — coordination complète assurée." },
    },
    coverage: {
      overline: "Nos zones",
      title: "Spécialistes des Alpes & de la Côte d'Azur",
      subtitle: "Deux terrains d'expertise, un même niveau de service — et une couverture longue distance qui va bien plus loin quand vous en avez besoin.",
      winterBase: { title: "Alpes & Savoie — notre terrain principal", desc: "Courchevel 1850, Val d'Isère, Tignes, Megève, Chamonix Mont-Blanc, Méribel, Val Thorens. Transferts depuis les aéroports de Genève, Chambéry, Annecy, Lyon ou Grenoble. Chauffeur dédié à la semaine, cortèges pour Noël, Nouvel An et vacances de février." },
      summerBase: { title: "Côte d'Azur — en complément", desc: "Nice, Cannes, Monaco, Saint-Tropez, Cap-Ferrat, Antibes, Èze, Villefranche. Service disponible toute l'année : Festival de Cannes, Grand Prix de Monaco, Yacht Show, mariages Riviera." },
      france: { title: "France entière & frontières", desc: "Longue distance sur mesure : Paris, Lyon, Bordeaux, Genève, Milan, Barcelone. Nous traversons naturellement Espagne, Italie, Monaco et Suisse selon vos besoins — sur devis." },
      note: "Deux zones principales, saisons complémentaires. Longue distance sur devis pour toute la France et les frontières.",
      cta: "Demander un devis",
    },
    reviews: {
      overline: "Ils nous font confiance",
      title: "Avis de nos clients",
      empty: "Soyez le premier à laisser un avis !",
      leaveBtn: "Laisser un avis Google",
      leaveInternal: "ou laisser un mot ici",
      form: {
        name: "Votre nom",
        trip: "Votre trajet / prestation (optionnel)",
        tripPh: "Ex : Transfert Nice → Cannes",
        text: "Votre avis",
        textPh: "Partagez votre expérience…",
        rating: "Votre note",
        submit: "Publier mon avis",
        sending: "Envoi…",
        thanks: "Merci pour votre avis !",
        thanksDesc: "Il sera publié après validation.",
        error: "Une erreur est survenue. Réessayez.",
      },
    },
    booking: {
      overline: "Devis",
      title: "Demandez votre devis",
      subtitle: "Tout trajet, toute prestation — réponse rapide par email ou WhatsApp.",
      typeTransfer: "Transfert",
      typeDisposal: "Mise à dispo",
      typeEvent: "Événement",
      name: "Nom complet", phone: "Téléphone", email: "Email",
      date: "Date", time: "Heure", pickup: "Lieu de prise en charge", dropoff: "Destination",
      passengers: "Passagers", message: "Message (optionnel)",
      duration: "Durée souhaitée",
      durations: ["4 heures", "6 heures", "8 heures", "Journée complète", "Plusieurs jours"],
      vehicles: "Véhicules souhaités", vehicleUnit: "véhicule(s)",
      event: "Type d'événement", eventPh: "Sélectionner…",
      eventTypes: [
        "Festival de Cannes",
        "Grand Prix de Monaco",
        "Yacht Show",
        "Mariage",
        "Séminaire",
        "Soirée privée",
        "Autre",
      ],
      eventDetailsPh: "Précisez : lieu, horaires, nombre de jours, exigences particulières…",
      pickupPh: "Aéroport Genève, Chambéry, hôtel, chalet…", dropoffPh: "Courchevel, Val d'Isère, Monaco…",
      submit: "Envoyer ma demande", sending: "Envoi en cours…",
      success: "Demande envoyée !", successDesc: "Nous revenons vers vous très rapidement.",
      whatsappFollow: "Envoyer aussi sur WhatsApp",
      error: "Une erreur est survenue. Réessayez ou contactez-nous directement.",
      orContact: "Ou contactez-nous directement",
      passengerUnit: "passager(s)",
      cgvNotice: "En envoyant votre demande, vous acceptez nos",
      cgvLink: "conditions générales de vente",
      promiseEmail: "Réponse par email dans les meilleurs délais",
      promiseWhatsapp: "Réponse WhatsApp dans les meilleurs délais",
      quickTitle: "Réservez votre trajet",
      quickSubtitle: "Sans engagement · Réponse rapide",
      vehicleType: "Type de véhicule",
      vehicleAny: "Indifférent",
      vehiclePax: "pax",
      callCta: "Appeler",
      estimating: "Calcul du trajet…",
      roundtrip: "Aller-retour",
      returnDate: "Date de retour",
      returnTime: "Heure de retour",
    },
    floating: { whatsapp: "WhatsApp", call: "Appeler", email: "Email", callLabel: "Appelez-nous" },
    servicesPage: {
      title: "Services & Flotte",
      subtitle: "Tout ce que nous proposons sur la Côte d'Azur — et les véhicules qui vous attendent.",
      event: { title: "Un événement à organiser ?", desc: "Mariage, festival, Grand Prix, séminaire… Précisez votre demande : nous construisons la prestation sur mesure avec vous.", cta: "Préciser ma demande" },
    },
    contactPage: {
      title: "Contact & Avis",
      subtitle: "Parlez-nous — ou découvrez ce que nos clients disent de nous.",
    },
    footer: {
      tagline: "Chauffeur privé prestige — Alpes · Savoie · Côte d'Azur · Longue distance en France entière",
      rights: "Tous droits réservés.",
      cgv: "Conditions générales de vente",
      blogLink: "Le blog",
      faqLink: "Questions fréquentes",
    },
    blog: {
      overline: "Guides & itinéraires",
      title: "Le carnet AMB Élite",
      subtitle: "Nos guides prestige pour vivre les Alpes et la Côte d'Azur autrement — stations, palaces, villages perchés, itinéraires en chauffeur privé.",
      backHome: "Retour à l'accueil",
      backList: "Tous les articles",
      readMore: "Lire l'article",
      frNotice: "Articles disponibles en français",
      crumbHome: "Accueil",
      crumbBlog: "Blog",
      ctaOverline: "AMB Élite",
      ctaTitle: "Prêt à partir en chauffeur privé ?",
      ctaSubtitle: "Devis personnalisé dans les meilleurs délais. Mercedes Classe V, S et E. Service 24/7.",
      ctaButton: "Demander un devis",
      relatedTitle: "À lire aussi",
      waCta: "Discuter sur WhatsApp",
      waBubble: "Une question sur ce voyage ?",
      waSampleArticle: "Bonjour ! J'aimerais un devis pour ce trajet.",
      waMessage: "Bonjour, je m'intéresse à un voyage en chauffeur privé suite à votre article « {title} ». Pourriez-vous m'envoyer un devis personnalisé ?",
    },
    floatingWA: {
      profileName: "AMB Élite",
      profileTagline: "En ligne · Réponse rapide",
      cta: "Démarrer la discussion",
      bubble: "💬 Une question ? On vous répond vite.",
      sampleMessage: "Bonjour, je voudrais un devis pour un transfert privé en chauffeur. Pouvez-vous m'aider ?",
      messageTemplate: "Bonjour, je voudrais un devis pour un transfert privé en chauffeur AMB Élite. Pouvez-vous m'aider ?",
    },
    cgv: {
      title: "Conditions générales de vente",
      officialNote: "",
      backHome: "Retour au site",
    },
    experience: {
      overline: "L'expérience AMB Élite",
      title: "Chauffeur en costard, Mercedes noire, discrétion absolue",
      subtitle:
        "De l'Aéroport Nice aux palaces de la Riviera, nos chauffeurs vous accueillent en costume sombre au volant de Mercedes Classe V, S ou E. Ponctualité au quart d'heure près, conduite souple, intérieur impeccable — la même exigence pour chaque trajet.",
      bullets: [
        "Tenue costume sombre & cravate",
        "Mercedes-Benz récentes uniquement",
        "Meet & Greet à l'aéroport et sur tarmac",
      ],
      cta: "Réserver mon chauffeur",
    },
    signature: {
      overline: "Notre signature",
      title: "Un salon privé sous les étoiles",
      subtitle: "Nos Mercedes Classe V sont aménagées comme un lounge premium : ciel étoilé fibre optique, grand écran HD avec Netflix & Prime Video, cuir pleine fleur. Idéal pour les longs transferts vers Saint-Tropez, les enfants à bord, ou simplement pour arriver détendu à votre événement.",
      features: [
        { title: "Ciel étoilé fibre optique", desc: "Plafond constellé en bleu, rouge ou violet — ajustable selon votre humeur." },
        { title: "Écran HD · Netflix & Prime", desc: "Profitez de vos séries et films en streaming pendant le trajet." },
        { title: "Cuir & finition premium", desc: "Sièges capitaine en cuir noir, repose-pieds, accoudoirs ajustables." },
        { title: "Wi-Fi & chargeurs", desc: "Restez connecté. USB et prises 220V disponibles à bord." },
      ],
      cta: "Réserver un Classe V",
    },
    onBoard: {
      overline: "À bord",
      title: "Le voyage commence avant l'arrivée",
      subtitle: "Trois ambiances, une exigence : faire de chaque kilomètre un moment privilégié. Familles, clientèle d'affaires ou voyageurs grande distance — vous arrivez aussi reposé qu'au départ.",
      cards: [
        { title: "En famille, vers Saint-Tropez", desc: "Les enfants regardent Netflix sous le ciel étoilé. Vous, vous fermez les yeux. Le chauffeur s'occupe du reste — bagages, péages, pauses." },
        { title: "Soirée VIP, événements et palaces", desc: "Festival, dîner, soirée privée : le chauffeur attend devant l'entrée, costume sombre, voiture impeccable. Vous arrivez exactement à l'heure, exactement où il faut." },
        { title: "Longue distance, du lever au coucher du soleil", desc: "Nice, Paris, Genève, Milan… Pour les trajets longue distance, la Classe E offre l'élégance discrète d'une berline business. Wifi, eau offerte, conduite souple." },
      ],
      cta: "Demander mon devis",
    },
    terrains: {
      overline: "La maison AMB Élite",
      title: "Une présence sur toute la France",
      subtitle: "AMB Élite est spécialisée sur les stations alpines (Courchevel, Val d'Isère, Tignes, Megève, Chamonix) et opère également sur la Côte d'Azur en complément — soirées VIP, mariages, Festival de Cannes, Grand Prix de Monaco — ainsi qu'en longue distance partout en France et aux frontières.",
      captions: [
        "France entière",
        "Alpes & Savoie · spécialité",
        "Côte d'Azur · en complément",
        "Soirées VIP & palaces",
        "Longue distance",
      ],
    },
    vipArrival: {
      overline: "L'arrivée VIP",
      title: "Le tapis rouge commence à votre portière",
      subtitle: "Chauffeur en costume sombre, accueil personnalisé devant l'entrée, valise prise en main, portière tenue. Vous descendez. Le reste suit.",
      cta: "Réserver mon arrivée",
      alt: "Client VIP descendant d'une berline noire — AMB Élite",
    },
    seo: {
      home: {
        title: "AMB Élite — Chauffeur privé Alpes & Savoie · Transferts Genève, Chambéry, Lyon → Courchevel, Val d'Isère, Tignes",
        description: "Chauffeur privé haut de gamme pour les Alpes et la Savoie. Transferts aéroports Genève, Chambéry, Annecy, Lyon, Grenoble vers Courchevel, Val d'Isère, Tignes, Megève, Chamonix. Mercedes Classe V (notre flotte), Classe S & E via partenaires. Également Côte d'Azur et longue distance en France entière. Service 24/7.",
        keywords: "chauffeur privé Alpes, chauffeur privé Savoie, chauffeur privé Courchevel, chauffeur privé Val d'Isère, chauffeur privé Tignes, chauffeur privé Megève, chauffeur privé Chamonix, chauffeur privé Chambéry, chauffeur privé Annecy, chauffeur privé Val Thorens, chauffeur privé Méribel, chauffeur privé Les Arcs, chauffeur privé La Plagne, chauffeur privé Les Trois Vallées, transfert aéroport Genève Courchevel, transfert aéroport Genève Val d'Isère, transfert aéroport Genève Tignes, transfert aéroport Genève Megève, transfert aéroport Genève Chamonix, transfert aéroport Chambéry Courchevel, transfert aéroport Chambéry Val d'Isère, transfert aéroport Lyon Courchevel, transfert aéroport Lyon Val d'Isère, transfert aéroport Grenoble Alpe d'Huez, transfert aéroport Annecy Megève, navette aéroport stations ski, transfert VIP station ski, chauffeur ski Savoie, VTC Alpes, VTC Savoie, VTC Chambéry, VTC Annecy, VTC Courchevel, VTC Val d'Isère, VTC Tignes, VTC Megève, VTC Chamonix, chauffeur de maître Alpes, chauffeur de maître Savoie, chauffeur prestige stations ski, driver privé Alpes, private driver Alps, private driver Courchevel, private driver Val d'Isère, private ski transfer, luxury ski transfer, VIP ski transfer, ski transfer Geneva Courchevel, Geneva airport ski transfer, chauffeur à la semaine Alpes, chauffeur semaine Courchevel, mise à disposition chauffeur Val d'Isère, Mercedes Classe V transfert ski, Mercedes V-Class ski transfer, van VIP 7 places Alpes, chauffeur Mariage Megève, chauffeur Noël Courchevel, chauffeur Nouvel An Val d'Isère, chauffeur vacances février Tignes, chauffeur privé Côte d'Azur, chauffeur privé Nice, chauffeur privé Monaco, chauffeur privé Cannes, longue distance France chauffeur, AMB Élite, AMB Elite chauffeur Alpes",
      },
      services: {
        title: "Services & Flotte Mercedes V S E — Chauffeur privé prestige AMB Élite · Alpes & Côte d'Azur",
        description: "Tous nos services de chauffeur privé AMB Élite : transferts aéroports (Genève, Chambéry, Annecy, Lyon, Grenoble) vers Courchevel, Val d'Isère, Tignes, Megève, Chamonix. Également Côte d'Azur : Aéroport Nice, Cannes-Mandelieu, mariages, Festival de Cannes, Grand Prix de Monaco, Yacht Show. Mise à disposition, cortèges. Flotte Mercedes Classe V (en propriété), Classe S & E AMG (via partenaires).",
        keywords: "services chauffeur privé Côte d'Azur, services VTC Nice, services VTC Monaco, flotte Mercedes chauffeur Nice, Mercedes Classe V Nice, Mercedes Classe V Cannes, Mercedes Classe V Monaco, Mercedes Classe V Saint-Tropez, Mercedes Classe S Côte d'Azur, Mercedes Classe S Monaco, Mercedes Classe E AMG, Mercedes Classe E chauffeur, Mercedes V-Class private driver, Mercedes S-Class chauffeur, Mercedes E-Class chauffeur, van 7 places chauffeur Nice, Mercedes Vito VIP, transfert Aéroport Nice Côte d'Azur, transfert NCE, transfert aéroport Cannes-Mandelieu, transfert héliport Monaco, transfert héliport Cannes, transfert héliport Saint-Tropez, transfert gare Nice-Ville, transfert gare Cannes, mise à disposition Nice journée, mise à disposition Cannes journée, mise à disposition Monaco journée, mise à disposition plusieurs jours Riviera, chauffeur Festival de Cannes, chauffeur Cannes Film Festival, chauffeur Grand Prix Monaco F1, chauffeur Monaco Yacht Show, chauffeur MIPIM Cannes, chauffeur MIDEM Cannes, chauffeur Cannes Lions, chauffeur mariage Côte d'Azur, voiture cortège mariage Cannes, cortège délégation Monaco, chauffeur séminaire d'entreprise Nice, chauffeur incentive Riviera, chauffeur road show Côte d'Azur, sécurité privée chauffeur, agent de sécurité protection rapprochée Monaco, chauffeur garde du corps Côte d'Azur, transport VIP célébrités Riviera, transport personnalités French Riviera, chauffeur diplomate Monaco, transferts longue distance France, Nice Genève, Nice Milan, Nice Turin, Nice Paris, Nice Lyon, transfert Marseille Côte d'Azur, transfert Saint-Tropez Aéroport Nice, chauffeur Mougins, chauffeur La Croisette, chauffeur Place Masséna, chauffeur Promenade des Anglais, chauffeur Cap d'Antibes, chauffeur Beaulieu-sur-Mer, chauffeur Menton, chauffeur Beausoleil, chauffeur Roquebrune-Cap-Martin",
      },
      contact: {
        title: "Contact, Avis & WhatsApp — Chauffeur privé prestige AMB Élite",
        description: "Contactez AMB Élite — chauffeur privé prestige Alpes & Côte d'Azur. Téléphone +33 6 80 92 76 70, WhatsApp 7j/7, Instagram @amb.elite, emails office@ambelite.com et amb.elite.alpes@gmail.com. Avis clients vérifiés.",
        keywords: "contact chauffeur privé Nice, contact VTC Côte d'Azur, contact chauffeur Monaco, contact chauffeur Cannes, WhatsApp chauffeur Nice, WhatsApp chauffeur privé Côte d'Azur, WhatsApp VTC Monaco, réservation chauffeur Riviera, réservation transfert Aéroport Nice, devis chauffeur privé Côte d'Azur, devis transfert Monaco, devis mariage Cannes, avis VTC Côte d'Azur, avis chauffeur privé Nice, avis chauffeur Monaco, témoignages French Riviera Transfert, AMB Élite contact, Instagram amb.elite, amb.elite.alpes@gmail.com, office@ambelite.com, partenariat hôtel Côte d'Azur, partenariat conciergerie Monaco, partenariat villa Saint-Tropez",
      },
      cgv: {
        title: "Conditions Générales de Vente — Chauffeur privé AMB Élite",
        description: "CGV du service de chauffeur privé VTC AMB Élite (EURL, RCS Chambéry 995 262 474, EVTC073260010). Réservation, devis, prestations, annulation, responsabilités, RGPD.",
        keywords: "CGV French Riviera Transfert, conditions générales chauffeur privé Côte d'Azur, conditions VTC Nice, conditions générales transfert Monaco, AMB Élite EURL, EVTC073260010, RCS Chambéry 995262474, conditions chauffeur Mercedes Côte d'Azur, RGPD chauffeur privé",
      },
    },
    seoFooter: {
      title: "Chauffeur privé prestige · Alpes · Savoie · Côte d'Azur · Driver Mercedes",
      lines: [
        "Alpes & stations de ski : Courchevel 1850 · Val d'Isère · Tignes · Méribel · Val Thorens · Les Trois Vallées · Espace Killy · Megève · Chamonix Mont-Blanc · Saint-Gervais · Serre Chevalier · Alpe d'Huez · Les Deux Alpes · La Plagne · Les Arcs · Paradiski · La Rosière · Sainte-Foy Tarentaise · Isola 2000 · Auron · Valberg · transferts aéroports Genève · Chambéry · Annecy · Lyon · Grenoble → stations · retour ski Genève & Nice",
        "Côte d'Azur : Nice · Cannes · Monaco · Monte-Carlo · Saint-Tropez · Cap-Ferrat · Antibes · Juan-les-Pins · Èze · Villefranche-sur-Mer · Beaulieu-sur-Mer · Menton · Roquebrune-Cap-Martin · Mougins · Saint-Paul-de-Vence · Vence · La Croisette · Promenade des Anglais · Mandelieu-la-Napoule · Théoule-sur-Mer",
        "Aéroports, gares & longue distance : Aéroport Genève (GVA) · Aéroport Chambéry Savoie (CMF) · Aéroport Annecy (NCY) · Aéroport Lyon-Saint-Exupéry (LYS) · Aéroport Grenoble-Alpes-Isère (GNB) · Aéroport Nice Côte d'Azur (NCE) · Cannes-Mandelieu · Héliports Monaco / Cannes / Saint-Tropez (La Môle) · Gares Chambéry · Bourg-Saint-Maurice · Moûtiers · Albertville · Nice · Cannes · Antibes · Monaco · FBO Sky Valet & Landmark · Alpes ↔ Paris · Alpes ↔ Lyon · Alpes ↔ Genève · Nice ↔ Milan · Monaco ↔ Turin · Portofino · Sanremo · Côme · Barcelone",
        "Prestations : transfert aéroport station de ski · navette VIP stations · meet & greet aviation d'affaires · mise à disposition 4h / 6h / 8h / journée / multi-jours · chauffeur à la semaine en station · cortège mariage · chauffeur Festival de Cannes · Grand Prix de Monaco F1 · Monaco Yacht Show · MIPIM · MIDEM · séminaires & incentives · transport célébrités · protection rapprochée",
        "Flotte : Mercedes Classe V — notre véhicule en pleine propriété, van VIP 7 pax, ciel étoilé fibre optique, Netflix & Prime · Classe S · Classe E AMG · Maybach sur demande via nos partenaires — chauffeur privé · VTC · private driver · executive chauffeur · luxury car service · limousine · transfert ski · airport transfer · anglophone · service 24/7 · WhatsApp",
      ],
    },
  },

  en: {
    nav: { home: "Home", servicesPage: "Services & Fleet", fleetPage: "Fleet", contactPage: "Contact & Reviews", book: "Get a quote", themeDark: "Switch to alpine night", themeLight: "Switch to light mode" },
    landing: {
      hero: {
        titleLine1: "Private chauffeur",
        titleLine2: "Alps & Savoie",
        subtitlePre: "Private transfers from the airports of ",
        subtitleBold1: "Geneva, Chambéry, Annecy, Lyon and Grenoble",
        subtitleMid: " to ",
        subtitleBold2: "Courchevel, Val d'Isère, Tignes, Megève and Chamonix",
        subtitlePost: ". Weekly chauffeur service, motorcades and hourly hire across every Alpine resort — also available on the French Riviera and for your long-distance trips across France.",
        tags: {
          ski: "Resort transfers",
          airports: "Alpine airports",
          dedicated: "Weekly chauffeur",
          event: "Events & Motorcades",
          riviera: "French Riviera",
          longhaul: "Long distance",
        },
        ctaQuote: "Get a quote",
        ctaDiscover: "Discover the maison",
        rating: "5.0 · Google",
        trust24: "Available 24/7",
        trustReply: "Fast reply",
        trustDiscretion: "Absolute discretion",
      },
      prestations: {
        overline: "Our services",
        titleLine1: "Six ways to ",
        titleLine2: "travel with us",
        subtitle: "Every service is tailored to you. We study your request, select the most suitable vehicle and chauffeur, and send you a detailed quote within four hours.",
        detailsCta: "Details",
        services: {
          ski: { title: "Ski resort transfers", subtitle: "Alpine & Savoie airports", text: "From Geneva, Chambéry, Annecy, Lyon or Grenoble to Courchevel, Val d'Isère, Tignes, Megève, Chamonix. Flight tracking, luggage and skis on board." },
          dedicated: { title: "Weekly chauffeur", subtitle: "In resort, Sunday to Saturday", text: "A dedicated chauffeur for the full week in resort — restaurants, slopes, return airport. Ideal for families and Christmas, New Year or winter holiday stays." },
          disposal: { title: "Hourly hire", subtitle: "By the hour, by the day, long term", text: "A private chauffeur at your disposal — a few hours, a full day, a complete stay. You step in, you step out, you resume." },
          event: { title: "Events & Motorcades", subtitle: "Weddings, galas, festivals, GP", text: "Mountain weddings, corporate seminars, Cannes Film Festival, Monaco Grand Prix, Yacht Show — full coordination and Mercedes motorcades." },
          riviera: { title: "French Riviera", subtitle: "Alongside our Alpine activity", text: "Nice, Cannes, Monaco, Saint-Tropez, Cap-Ferrat: transfers, evenings, hourly hire. Rapid response, even at the last minute." },
          longhaul: { title: "Long distance", subtitle: "France, Monaco, Italy, Switzerland, Spain", text: "Alps ↔ Paris, Lyon, Geneva, Milan. Nice ↔ Paris, Barcelona, Portofino. Bespoke long-distance journeys, full comfort, no mileage limit." },
        },
      },
      fleetPreview: {
        overline: "Our fleet",
        titleLine1: "Three Mercedes signatures,",
        titleLine2: "zero compromise.",
        introPre: "Our ",
        introBold1: "Mercedes V-Class",
        introMid: " is our fully owned vehicle, maintained and briefed in-house. The ",
        introBold2: "S-Class and E-Class",
        introAfterBold2: ", along with exception cars (",
        introItalic: "Maybach, Rolls-Royce, Bentley, Ferrari",
        introPost: "), are mobilised through our carefully selected network of partner chauffeurs.",
        detailsCta: "Details",
        viewAll: "View the full fleet",
        cars: {
          v: { kicker: "VIP van · Our fleet", title: "Mercedes V-Class", line: "Our signature vehicle, fully owned — up to 6 passengers (real comfort plus luggage), fibre-optic starlit ceiling, screens and captain seats. Ideal for resort transfers with luggage and skis.", photoAlt: "AMB Élite Mercedes V-Class, fully owned VIP van — French Riviera and Alpine resorts" },
          s: { kicker: "Saloon · Via partners", title: "Mercedes S-Class", line: "Business discretion, silent ride, lounge rear — mobilised through our trusted partner network for executives and VIP missions.", photoAlt: "Black Mercedes S-Class from the front — AMB Élite directorial saloon (partners)" },
          e: { kicker: "AMG Coupé · Via partners", title: "Mercedes E-Class AMG", line: "A sport-luxe coupé available through our partner chauffeurs for standout arrivals, short escorts and transfers for two.", photoAlt: "Black Mercedes E-Class AMG Coupé — AMB Élite service via partners" },
        },
      },
      destinations: {
        overline: "Our destinations",
        titleLine1: "Where ",
        titleLine2: "we drive",
        subtitle: "Two territories, one standard of excellence — the Alps as our priority, the French Riviera alongside. Every address is known to our chauffeurs, every itinerary prepared in advance.",
        alpes: {
          kicker: "Alps & Savoie · Our specialty",
          title: "The great resorts, in Mercedes",
          textPre: "",
          textBold1: "Courchevel",
          textMid1: ", ",
          textBold2: "Val d'Isère",
          textMid2: " and ",
          textBold3: "Tignes",
          textPost: " — three home resorts for AMB Élite. Transfers from Geneva, Chambéry, Annecy, Lyon or Grenoble, dedicated weekly chauffeur, winter-equipped vehicles.",
          prefillAriaPrefix: "Pre-fill the quote with destination",
          prefillHint: "Quote",
        },
        riviera: {
          kicker: "French Riviera · Alongside",
        },
      },
      ourHouse: {
        overline: "The AMB Élite Maison",
        titleLine1: "A chauffeur maison,",
        titleLine2: "not a service.",
        paragraph1: "AMB Élite was born from a simple conviction: true luxury does not lie in the car, but in the person at the wheel. We are a small-scale maison, bringing together a tight team of hand-picked chauffeurs — each chosen for their sense of service, their discretion and their deep knowledge of the places they drive through.",
        paragraph2Pre: "We accompany corporate leaders, affluent families, international productions and palace guests throughout their journeys. From the ",
        paragraph2Bold1: "Alps",
        paragraph2Mid: " to the ",
        paragraph2Bold2: "French Riviera",
        paragraph2Post: ", from Paris to Milan, our services cover the whole of France and extend naturally into Italy, Switzerland, Spain and the Principality of Monaco.",
        paragraph3Pre: "Our main vehicle — the ",
        paragraph3Bold1: "Mercedes V-Class",
        paragraph3Mid: " — is fully owned, meticulously maintained and adapted to every occasion. For the Mercedes ",
        paragraph3Bold2: "S-Class and E-Class",
        paragraph3AfterBold2: ", and for the most particular requests, we mobilise on demand exception cars (",
        paragraph3Italic: "Maybach, Rolls-Royce, Bentley",
        paragraph3Post: ") and a carefully curated network of partner chauffeurs, close-protection officers, hoteliers and wedding planners.",
        ctaStory: "Our story",
        ctaQuote: "Get a quote",
        statLabel: "Round-the-clock availability",
        statHint: "Quotes within the shortest timeframe, by WhatsApp or email",
        photoAlt: "AMB Élite Mercedes V-Class in front of an Alpine chalet in Courchevel — private ski resort transfer",
      },
      manifesto: {
        overline: "Our manifesto",
        titleLine1: "Every journey",
        titleLine2a: "is ",
        titleLine2b: "a signature",
        titleLine2c: ".",
        subtitle: "A small-scale maison, committed to the only craft it truly knows: driving, with excellence.",
        paragraph1: "Excellence begins long before the door opens. It hides in the details no one sees — the spotless carpet, the chill of a bottle of water placed with care, the exact short-cut that gets you to your appointment on time despite the Festival motorcades. AMB Élite was built on this conviction: luxury is not what is shown, but what is felt.",
        paragraph2: "We do not sell kilometres. We accompany moments — sometimes ordinary, often decisive. A business meeting in Monaco, a wedding on the heights of Cap-Ferrat, a private transfer for a family stepping off a jet at Nice-Côte d'Azur. Every service is studied in advance, double-checked rather than once, and entrusted to a chauffeur we know personally.",
        paragraph3: "Our chauffeurs speak fluent English, know Courchevel, Val d'Isère and the French Riviera like the back of their hand, and know when to speak just as well as when to stay silent. Dressed in a dark suit — black or midnight blue — with a discreet tie, they embody a certain idea of French service: precise, warm, never ostentatious.",
        pillars: [
          { kicker: "Craft", label: "of a private chauffeur trained to the codes of grand luxury — French Riviera, Alps, all of France" },
          { kicker: "Small team", label: "of hand-picked chauffeurs trained in VIP driving" },
          { kicker: "24/7", label: "continuous availability, reply within the shortest timeframe" },
          { kicker: "French · English", label: "crystal-clear communication with international clients, no detours" },
        ],
        quote: "“What distinguishes a chauffeur from an exceptional one is what the client does not notice. The ride should feel effortless — everything else is our concern.”",
        quoteAuthor: "— Quentin Bernard, founder AMB Élite",
        ctaStory: "Our full story",
        ctaQuote: "Get a quote",
      },
      territoires: {
        overline: "Our territories",
        titleLine1: "Two grounds.",
        titleLine2: "One standard of service.",
        introPre: "AMB Élite specialises first in the ",
        introBold1: "Alps and Savoie",
        introMid: ", and also accompanies clients on the ",
        introBold2: "French Riviera",
        introPost: " and everywhere in France, year-round.",
        alpes: {
          overline: "Our main territory",
          kicker: "Alps & Savoie",
          titleLine1: "The Alps,",
          titleLine2: "the snow setting",
          bodyPre: "Courchevel, Val d'Isère, Tignes, Megève, Chamonix — our priority area of expertise. Transfers from the airports of Geneva, Chambéry, Annecy, Lyon or Grenoble, dedicated weekly chauffeur in resort, motorcades for Christmas, New Year and ",
          bodyItalic: "winter holiday",
          bodyPost: " stays. Winter-equipped vehicles, chauffeurs seasoned on mountain roads.",
          spots: ["Courchevel 1850", "Val d'Isère", "Tignes", "Megève", "Chamonix Mont-Blanc", "Méribel · Val Thorens", "Geneva · Chambéry · Annecy", "Lyon · Grenoble"],
          cta: "Discover the Alps",
          photoAlt: "AMB Élite Mercedes V-Class in front of an Alpine chalet, red starlit ceiling interior — Courchevel",
        },
        riviera: {
          overline: "Alongside",
          kicker: "French Riviera",
          titleLine1: "The Riviera,",
          titleLine2: "in absolute luxury",
          bodyPre: "From Nice to Saint-Tropez, through Monaco, Cannes, Cap-Ferrat and Èze — we also handle transfers and hourly hire on the French Riviera, with peak intensity from May to September: ",
          bodyItalic: "Cannes Film Festival, Monaco Grand Prix, Yacht Show, Riviera weddings",
          bodyPost: ".",
          spots: ["Nice", "Monaco · Monte-Carlo", "Cannes · Croisette", "Saint-Tropez", "Saint-Jean-Cap-Ferrat", "Antibes · Juan-les-Pins", "Èze · Villefranche", "Sanremo · Italy"],
          cta: "Discover the Riviera",
          photoAlt: "AMB Élite Mercedes V-Class under a parasol pine facing the Mediterranean, French Riviera",
        },
      },
    },
    home: {
      strip: ["Luxury service", "Nice Airport transfers", "Hourly hire", "Major events", "Private security"],
      destinations: {
        overline: "Our destinations",
        title: "The French Riviera, in absolute luxury",
        subtitle: "Nice, Cannes, Monaco, Saint-Tropez, Cap-Ferrat, Antibes, Èze… We cover the entire French Riviera, 7 days a week.",
        list: RIVIERA_DESTINATIONS,
        cta: "Get a quote",
        prefillHint: "Pre-fill the quote",
        prefillAriaPrefix: "Pre-fill the quote with destination",
      },
      niceTransfers: {
        overline: "Main hub",
        title: "Transfers from Nice Côte d'Azur Airport",
        subtitle: "Private chauffeur welcome, Meet & Greet, flight tracking, transfers to 5★ hotels, private villas, yachts and VIP events.",
        hubLabel: "Nice Côte d'Azur Airport",
        routes: NICE_ROUTES,
        also: "Also: Cannes-Mandelieu Airport, private helipads (Monaco, Cannes, Saint-Tropez), business aviation and long-distance trips across all of France on request.",
        cta: "Book my transfer",
        prefillHint: "Pre-fill the quote",
        prefillAriaPrefix: "Pre-fill the quote",
      },
    },
    hero: {
      winter: {
        overline: "VIP private chauffeur · Alps & Rhône-Alpes",
        chip: "Winter season — Alps & ski resorts",
        title: "Excellence on the roads of the Alps",
        subtitle: "Transfers and hourly hire in Mercedes V, S & E-Class.",
      },
      summer: {
        overline: "VIP private chauffeur · French Riviera",
        chip: "Nice Airport · Monaco · Cannes · Saint-Tropez · Cap-Ferrat",
        title: "Your VIP private chauffeur on the French Riviera",
        subtitle: "Nice Airport transfers, hourly hire and major events in Mercedes V, S & E-Class. 24/7 service across the entire Riviera — and long-distance trips anywhere in France on request.",
      },
      cta: "Get a quote",
      discover: "Discover our services",
    },
    banner: {
      title: "Need an immediate departure?",
      text: "Unexpected situation? Stranded somewhere? We reply within minutes on WhatsApp, 7 days a week — even last minute.",
      cta: "Message us on WhatsApp",
    },
    services: {
      overline: "Our services",
      title: "Premium service, without compromise",
      subtitle: "Every service is tailored to you: a dedicated chauffeur, a prepared vehicle, a briefing on your preferences in advance. All you have to do is step on board.",
      badge: "Speciality",
      ski: { title: "Ski resort transfers", desc: "Courchevel, Val d'Isère, Méribel, Tignes… Winter service on request, long-distance trips anywhere in France." },
      riviera: { title: "French Riviera — maximum availability", desc: "Nice, Cannes, Monaco, Saint-Tropez, Cap-Ferrat: transfers, evenings, hourly hire. Highly responsive, even last minute." },
      transfers: { title: "Nice Airport & long-distance transfers", desc: "Nice Côte d'Azur Airport, Cannes-Mandelieu, helipads, train stations. For long distances and major events, we travel anywhere in France." },
      disposal: { title: "Flexible hourly hire", desc: "A dedicated chauffeur and vehicle for as long as you choose. Add hours on the go, multiple vehicles and chauffeurs if needed." },
      events: { title: "Major events", desc: "Cannes Film Festival, Monaco Grand Prix, Yacht Show, weddings, seminars: flawless logistics, on the Riviera and beyond." },
      languages: { title: "International clientele", desc: "French-speaking drivers with fluent English. Our website is translated into 6 languages (French, English, Italian, German, Spanish, Arabic) to welcome you in yours." },
      security: { title: "Private security & protection", desc: "In partnership with private security agents for your most sensitive journeys: discretion and close protection on request." },
    },
    fleet: {
      overline: "Our fleet",
      title: "Mercedes-Benz, exclusively",
      desc: "Recent, immaculate vehicles, suited to every type of service.",
      classes: [
        { name: "V-Class", tag: "Up to 6 passengers", desc: "A private lounge on the road: ideal for families, groups and transfers with luggage." },
        { name: "S-Class", tag: "Absolute prestige", desc: "The benchmark of luxury for your most exceptional journeys and demanding clients." },
        { name: "E-Class", tag: "On request", desc: "Business elegance for your professional travel." },
      ],
      note: "Complimentary water · WiFi & chargers · Child seats on request",
      cortege: { title: "Motorcades & delegations", desc: "Up to 10 chauffeured vehicles for your motorcades, weddings, delegations and large groups — full coordination included." },
    },
    coverage: {
      overline: "Our areas",
      title: "French Riviera & Alps specialists",
      subtitle: "Two areas of expertise, one same service standard — plus long-distance coverage that goes much further when you need it.",
      summerBase: { title: "French Riviera — summer", desc: "Nice, Cannes, Monaco, Saint-Tropez, Cap-Ferrat, Antibes, Èze, Villefranche. 24/7 service year-round, peak intensity from May to September: Cannes Film Festival, Monaco Grand Prix, Yacht Show, Riviera weddings." },
      france: { title: "All of France & neighbouring countries", desc: "Custom long distance: Paris, Lyon, Bordeaux, Geneva, Milan, Barcelona. We naturally cross into Spain, Italy, Monaco and Switzerland when required — on quotation." },
      winterBase: { title: "Alps — winter", desc: "Val d'Isère, Tignes, Courchevel 1850, Megève, Chamonix Mont-Blanc. Transfers from Geneva, Lyon, Chambéry or Grenoble airports. Dedicated weekly chauffeur, festive convoys for Christmas, New Year and February holidays." },
      note: "Two primary areas, complementary seasons. Long distance available on quote for all of France and its borders.",
      cta: "Get a quote",
    },
    reviews: {
      overline: "They trust us",
      title: "Client reviews",
      empty: "Be the first to leave a review!",
      leaveBtn: "Leave a Google review",
      leaveInternal: "or leave a note here",
      form: {
        name: "Your name",
        trip: "Your trip / service (optional)",
        tripPh: "E.g.: Transfer Nice → Cannes",
        text: "Your review",
        textPh: "Share your experience…",
        rating: "Your rating",
        submit: "Publish my review",
        sending: "Sending…",
        thanks: "Thank you for your review!",
        thanksDesc: "It will be published after moderation.",
        error: "An error occurred. Please try again.",
      },
    },
    booking: {
      overline: "Quote",
      title: "Request your quote",
      subtitle: "Any trip, any service — fast response by email or WhatsApp.",
      typeTransfer: "Transfer",
      typeDisposal: "Hourly hire",
      typeEvent: "Event",
      name: "Full name", phone: "Phone", email: "Email",
      date: "Date", time: "Time", pickup: "Pick-up location", dropoff: "Destination",
      passengers: "Passengers", message: "Message (optional)",
      duration: "Desired duration",
      durations: ["4 hours", "6 hours", "8 hours", "Full day", "Several days"],
      vehicles: "Vehicles needed", vehicleUnit: "vehicle(s)",
      event: "Event type", eventPh: "Select…",
      eventTypes: [
        "Cannes Film Festival",
        "Monaco Grand Prix",
        "Yacht Show",
        "Wedding",
        "Seminar",
        "Private party",
        "Other",
      ],
      eventDetailsPh: "Tell us more: venue, schedule, number of days, special requirements…",
      pickupPh: "Nice Airport, hotel, villa…", dropoffPh: "Monaco, Cannes, Saint-Tropez…",
      submit: "Send my request", sending: "Sending…",
      success: "Request sent!", successDesc: "We will get back to you very quickly.",
      whatsappFollow: "Also send via WhatsApp",
      error: "An error occurred. Please try again or contact us directly.",
      orContact: "Or contact us directly",
      passengerUnit: "passenger(s)",
      cgvNotice: "By sending your request, you accept our",
      cgvLink: "terms & conditions of sale",
      promiseEmail: "Email reply within 4 hours",
      promiseWhatsapp: "WhatsApp reply as soon as possible",
      quickTitle: "Book your ride",
      quickSubtitle: "No commitment · Fast response",
      vehicleType: "Vehicle type",
      vehicleAny: "Any",
      vehiclePax: "pax",
      callCta: "Call",
      estimating: "Calculating route…",
      roundtrip: "Round trip",
      returnDate: "Return date",
      returnTime: "Return time",
    },
    floating: { whatsapp: "WhatsApp", call: "Call", email: "Email", callLabel: "Call us" },
    servicesPage: {
      title: "Services & Fleet",
      subtitle: "Everything we offer on the French Riviera — and the vehicles waiting for you.",
      event: { title: "An event to organise?", desc: "Wedding, festival, Grand Prix, seminar… Tell us your needs: we build the service with you, tailor-made.", cta: "Describe my request" },
    },
    contactPage: {
      title: "Contact & Reviews",
      subtitle: "Talk to us — or see what our clients say about us.",
    },
    footer: {
      tagline: "VIP private chauffeur — French Riviera · Long-distance trips across France",
      rights: "All rights reserved.",
      cgv: "Terms & conditions of sale",
      blogLink: "The blog",
      faqLink: "Frequently asked questions",
    },
    blog: {
      overline: "Guides & itineraries",
      title: "The French Riviera Journal",
      subtitle: "Our VIP guides to experiencing the French Riviera — palaces, beaches, hilltop villages and private-chauffeur itineraries.",
      backHome: "Back to homepage",
      backList: "All articles",
      readMore: "Read article",
      frNotice: "Articles currently available in French",
      crumbHome: "Home",
      crumbBlog: "Blog",
      ctaOverline: "French Riviera Transfert",
      ctaTitle: "Ready for your VIP transfer?",
      ctaSubtitle: "Personalised quote within 4 hours. Mercedes V-Class, S-Class and E-Class. 24/7 service.",
      ctaButton: "Request a quote",
      relatedTitle: "Also read",
      waCta: "A question about this trip?",
      waBubble: "Have a question? Let's chat on WhatsApp",
      waMessage: "Hello, I'm interested in a private chauffeur trip after reading your article « {title} ». Could you send me a personalised quote?",
    },
    cgv: {
      title: "Terms & conditions of sale",
      officialNote: "The legally binding version of these terms and conditions is the original French text below.",
      backHome: "Back to website",
    },
    experience: {
      overline: "The AMB Élite experience",
      title: "Suited chauffeurs, black Mercedes, absolute discretion",
      subtitle:
        "From Nice Airport to Riviera palaces, our chauffeurs welcome you in dark suits at the wheel of a Mercedes V, S or E-Class. Punctual to the minute, smooth driving, immaculate interior — the same standard for every ride.",
      bullets: [
        "Dark suit & tie attire",
        "Recent Mercedes-Benz only",
        "Airport & tarmac Meet & Greet",
      ],
      cta: "Book my chauffeur",
    },
    signature: {
      overline: "Our signature",
      title: "A private lounge under the stars",
      subtitle: "Our Mercedes V-Class are fitted out like a premium lounge: fibre-optic starry ceiling, large HD screen with Netflix & Prime Video, full-grain leather. Perfect for long transfers to Saint-Tropez, families with kids, or simply arriving relaxed at your event.",
      features: [
        { title: "Fibre-optic starry ceiling", desc: "A constellation in blue, red or purple — adjustable to your mood." },
        { title: "HD screen · Netflix & Prime", desc: "Enjoy your favourite series and films streaming during the ride." },
        { title: "Premium leather finish", desc: "Black leather captain seats, footrest, adjustable armrests." },
        { title: "Wi-Fi & chargers", desc: "Stay connected. USB and 220V outlets onboard." },
      ],
      cta: "Book a V-Class",
    },
    onBoard: {
      overline: "Onboard",
      title: "The journey starts before the arrival",
      subtitle: "Three moods, one standard: making every kilometre a privileged moment. Families, business clientele or long-distance travellers — you arrive as fresh as when you set off.",
      cards: [
        { title: "Family ride to Saint-Tropez", desc: "The kids watch Netflix under the starry ceiling. You close your eyes. The chauffeur takes care of the rest — luggage, tolls, stops." },
        { title: "VIP evenings, events & palaces", desc: "Festival, dinner, private party: the chauffeur waits at the door, dark suit, immaculate car. You arrive exactly on time, exactly where you need to be." },
        { title: "Long distance, from sunrise to sunset", desc: "Nice, Paris, Geneva, Milan… For long-distance trips, the E-Class offers the discreet elegance of a business sedan. Wi-Fi, complimentary water, smooth driving." },
      ],
      cta: "Get my quote",
    },
    terrains: {
      overline: "Our parent company: AMB Élite",
      title: "Present across all of France",
      subtitle: "French Riviera Transfert is AMB Élite's Côte d'Azur branch. Our parent company operates throughout France: French Riviera in summer, alpine resorts year-round, VIP nights, long-distance — wherever you go, we are there.",
      captions: [
        "All of France",
        "French Riviera · summer season",
        "Alps · year-round",
        "VIP nights & palaces",
        "Long distance",
      ],
    },
    vipArrival: {
      overline: "The VIP arrival",
      title: "The red carpet begins at your door",
      subtitle: "Dark-suited chauffeur, personal welcome at the entrance, luggage in hand, door held open. You step down. The rest follows.",
      cta: "Book my arrival",
      alt: "VIP client stepping out of a black sedan — French Riviera Transfert",
    },
    seo: {
      home: {
        title: "French Riviera Transfert — VIP Private Chauffeur · Nice · Cannes · Monaco · Saint-Tropez",
        description: "VIP private chauffeur service on the French Riviera by AMB Élite. Nice Airport transfers, hourly hire, weddings, Cannes Film Festival, Monaco Grand Prix, Yacht Show. Mercedes V-Class, S-Class & E-Class private driver. 24/7 service, reply within 4h, WhatsApp 7 days a week.",
        keywords: "private chauffeur Nice, private chauffeur Cannes, private chauffeur Monaco, private chauffeur Saint-Tropez, private chauffeur Cap-Ferrat, private chauffeur Antibes, private chauffeur Èze, private chauffeur Villefranche-sur-Mer, private chauffeur Menton, private chauffeur French Riviera, private chauffeur Côte d'Azur, VIP chauffeur Nice, VIP chauffeur Monaco, VIP chauffeur Cannes, VIP chauffeur Saint-Tropez, VIP chauffeur French Riviera, private driver Nice, private driver Monaco, private driver Cannes, private driver French Riviera, private driver Côte d'Azur, luxury driver Riviera, luxury chauffeur Côte d'Azur, executive driver Nice, executive chauffeur Monaco, English speaking driver Côte d'Azur, English speaking chauffeur Nice, Nice Airport transfer, Nice Airport private transfer, NCE airport transfer, Nice Airport to Monaco transfer, Nice Airport to Cannes transfer, Nice Airport to Saint-Tropez transfer, Nice Airport to Cap-Ferrat transfer, Nice Airport limousine, Nice Airport limo service, Cannes Mandelieu Airport transfer, Monaco helipad transfer, Cannes helipad transfer, Saint-Tropez helipad transfer, French Riviera car service, French Riviera limousine service, Côte d'Azur car service, Côte d'Azur limo service, Mercedes V-Class chauffeur, Mercedes V-Class Nice, Mercedes S-Class Monaco, Mercedes E-Class AMG chauffeur, Mercedes-Benz private driver, Mercedes Vito chauffeur Nice, VIP van Nice 7 passengers, hourly chauffeur hire Nice, hourly chauffeur hire Monaco, hourly chauffeur hire Cannes, day hire chauffeur Côte d'Azur, multi-day chauffeur Riviera, Cannes Film Festival driver, Cannes Film Festival chauffeur, Cannes Film Festival transport, Monaco Grand Prix chauffeur, Monaco Grand Prix F1 driver, Monaco Yacht Show chauffeur, MIPIM Cannes driver, MIDEM Cannes chauffeur, Cannes Lions driver, wedding car Côte d'Azur, wedding chauffeur Cannes, wedding motorcade Riviera, seminar chauffeur Nice, corporate driver Monaco, business chauffeur Côte d'Azur, celebrity transport French Riviera, VIP transport Riviera, diplomatic chauffeur Monaco, close protection driver Côte d'Azur, security driver Monaco, luxury taxi Monaco, luxury taxi Nice, luxury taxi Cannes, premium car service French Riviera, French Riviera Transfert, AMB Élite chauffeur",
      },
      services: {
        title: "Services & Mercedes V S E Fleet — French Riviera Transfert VIP Chauffeur",
        description: "All our VIP private chauffeur services on the French Riviera: Nice Airport & Cannes-Mandelieu transfers, hourly hire (4h, day, multi-day), weddings, Cannes Film Festival, Monaco Grand Prix, Yacht Show, motorcades up to 10 vehicles. 100% Mercedes-Benz fleet — V-Class (7 pax), S-Class, E-Class AMG.",
        keywords: "private chauffeur services French Riviera, chauffeur services Nice, chauffeur services Monaco, chauffeur services Cannes, Mercedes fleet chauffeur Nice, Mercedes V-Class Nice, Mercedes V-Class Cannes, Mercedes V-Class Monaco, Mercedes V-Class Saint-Tropez, Mercedes S-Class French Riviera, Mercedes S-Class Monaco, Mercedes E-Class AMG, Mercedes E-Class chauffeur Riviera, Mercedes-Benz chauffeur service, Mercedes Vito VIP Nice, 7 seater van Nice, Nice Airport private transfer, NCE private transfer, Cannes-Mandelieu Airport transfer, Monaco helipad transfer, Cannes helipad transfer, Saint-Tropez helipad transfer, Nice train station transfer, Cannes train station transfer, hourly chauffeur Nice, hourly chauffeur Monaco, day chauffeur Côte d'Azur, multi-day chauffeur Riviera, Cannes Film Festival private driver, Monaco Grand Prix F1 chauffeur, Monaco Yacht Show driver, MIPIM Cannes chauffeur, MIDEM Cannes driver, Cannes Lions chauffeur, wedding chauffeur French Riviera, wedding motorcade Cannes, delegation motorcade Monaco, corporate seminar chauffeur Nice, incentive trip Riviera chauffeur, road show driver Côte d'Azur, private security chauffeur, close protection driver Monaco, bodyguard chauffeur Côte d'Azur, celebrity transport Riviera, VIP transport French Riviera, diplomat chauffeur Monaco, long distance chauffeur France, Nice Geneva chauffeur, Nice Milan chauffeur, Nice Turin driver, Nice Paris chauffeur, Nice Lyon chauffeur, Marseille Côte d'Azur transfer, Saint-Tropez transfer Nice Airport, chauffeur Mougins, chauffeur La Croisette, chauffeur Promenade des Anglais, chauffeur Cap d'Antibes, chauffeur Beaulieu-sur-Mer, chauffeur Menton, chauffeur Beausoleil, chauffeur Roquebrune-Cap-Martin",
      },
      contact: {
        title: "Contact, Reviews & WhatsApp — French Riviera Transfert VIP Chauffeur",
        description: "Contact French Riviera Transfert (AMB Élite) — VIP private chauffeur Côte d'Azur. Phone +33 6 80 92 76 70, WhatsApp 7 days a week, Instagram @amb.elite, emails amb.elite.alpes@gmail.com and office@ambelite.com. Verified client reviews — Nice, Cannes, Monaco.",
        keywords: "contact private chauffeur Nice, contact private driver Monaco, contact private driver Cannes, contact French Riviera chauffeur, WhatsApp private driver Nice, WhatsApp chauffeur Monaco, WhatsApp Riviera chauffeur, book private chauffeur Riviera, book Nice Airport transfer, book Monaco transfer, book Cannes transfer, request quote French Riviera chauffeur, request quote Monaco transfer, request quote wedding Cannes, French Riviera chauffeur reviews, private driver Nice reviews, chauffeur Monaco reviews, testimonials French Riviera Transfert, AMB Élite contact, Instagram amb.elite, hotel partnership Côte d'Azur, concierge partnership Monaco, villa partnership Saint-Tropez",
      },
      cgv: {
        title: "Terms & Conditions — French Riviera Transfert Private Chauffeur (AMB Élite)",
        description: "Terms & Conditions of the French Riviera Transfert private chauffeur VTC service (AMB Élite EURL, RCS Chambéry 995 262 474, EVTC073260010). Booking, quote, services, cancellation, liabilities, GDPR.",
        keywords: "French Riviera Transfert terms, private chauffeur terms Côte d'Azur, VTC terms Nice, Monaco transfer terms, AMB Élite EURL, EVTC073260010, RCS Chambéry 995262474, Mercedes chauffeur terms Côte d'Azur, GDPR private chauffeur",
      },
    },
    seoFooter: {
      title: "VIP Private Chauffeur · French Riviera · Alps · Mercedes Driver Service",
      lines: [
        "French Riviera: Nice · Cannes · Monaco · Monte-Carlo · Saint-Tropez · Cap-Ferrat · Antibes · Juan-les-Pins · Èze · Villefranche-sur-Mer · Beaulieu-sur-Mer · Menton · Roquebrune-Cap-Martin · Mougins · Saint-Paul-de-Vence · Vence · La Croisette · Promenade des Anglais · Mandelieu-la-Napoule · Théoule-sur-Mer",
        "Alps & ski resorts: Val d'Isère · Tignes · Courchevel 1850 · Méribel · Val Thorens · Les Trois Vallées · Espace Killy · Megève · Chamonix Mont-Blanc · Saint-Gervais · Serre Chevalier · Alpe d'Huez · Les Deux Alpes · La Plagne · Les Arcs · Paradiski · La Rosière · Sainte-Foy Tarentaise · Isola 2000 · Auron · Valberg · ski return to Geneva & Nice · airport transfers Chambéry, Grenoble, Geneva → resorts",
        "Airports, stations & long distance: Nice Côte d'Azur Airport (NCE) · Cannes-Mandelieu · Monaco / Cannes / Saint-Tropez (La Môle) heliports · Nice · Cannes · Antibes · Monaco · Chambéry · Bourg-Saint-Maurice train stations · Sky Valet & Landmark FBO · French Riviera ↔ Paris · Nice ↔ Geneva · Cannes ↔ Milan · Monaco ↔ Turin · Portofino · Sanremo · Lake Como · Barcelona",
        "Services: airport transfer · VIP shuttle · meet & greet business aviation · hourly hire 4h / 6h / 8h / full day / multi-day · wedding motorcade · Cannes Film Festival chauffeur · Monaco Grand Prix F1 · Monaco Yacht Show · MIPIM · MIDEM · corporate seminars & incentives · Alps ski season chauffeur · celebrity transport · close protection",
        "100% Mercedes fleet: V-Class (VIP van 7 pax · fibre-optic starry ceiling · Netflix & Prime) · S-Class · E-Class AMG · Vito · Maybach on request — private chauffeur · private driver · executive chauffeur · luxury car service · limousine · ski transfer · airport transfer · English-speaking driver · 24/7 service · 4h reply · WhatsApp",
      ],
    },
  },
};
